import sendRequest from '../client/sendRequest';

const BASE_URL = '/api/products';

// Get all products
export async function getProducts() {
  return await sendRequest(BASE_URL, 'GET');
}

//Add a product
export async function postProduct(data) {
  return await sendRequest(BASE_URL, 'POST', data);
}

//Edit a product
export async function editProduct(id, data) {
  return await sendRequest(`${BASE_URL}/${id}`, 'PUT', data);
}

//Delete a product
export async function deleteProduct(id) {
  return await sendRequest(`${BASE_URL}/${id}`, 'DELETE');
}
